<template>
    <div class="board_sub_category_wrap" v-if="selectedCate?.rootCid">
        <ul :class="{ show: isShow }">
            <li :class="+this.$route.query.rootCid === +this.$route.query.cid ? 'selected' : ''">
                <router-link
                    :to="
                        +selectedCate.rootCid === +selectedCate.firstCategoryCid
                            ? {
                                  path: $route.path,
                                  query: {
                                      ...$route.query,
                                      cid: selectedCate.rootCid,
                                      rootCid: selectedCate.rootCid,
                                      keyword: '',
                                      searchType: '',
                                      page: '1',
                                  },
                              }
                            : {
                                  path: $route.path,
                                  query: { ...$route.query, page: 1, keyword: '', searchType: '' },
                              }
                    "
                    >전체</router-link
                >
            </li>
            <li v-for="(category, idx) in cateData.subCate" :key="idx" :class="+this.$route.query.cid === +category.cid ? 'selected' : ''">
                <router-link
                    :to="{
                        path: $route.path,
                        query: { ...$route.query, cid: category.cid, rootCid: category.rootCid, keyword: '', searchType: '', page: '1' },
                    }"
                    >{{ category.name }}
                </router-link>
            </li>
        </ul>
        <div class="hide_btn" v-if="cateData.subCate.length > 2" :class="{ on: isShow }" @click="toggleShow">
            더보기
            <span class="drop_arrow"><img src="@/assets/history_dropdown.png" alt="" /></span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        cateData: {},
        selectedCate: {},
    },
    data() {
        return {
            isShow: false,
        };
    },
    methods: {
        toggleShow() {
            this.isShow = !this.isShow;
        },
    },
};
</script>
<style lang="scss" scoped>
.board_sub_category_wrap {
    margin-bottom: 60px;

    @media screen and (max-width: 768px) {
        margin-bottom: 30px;
    }

    ul {
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 1024px) {
            flex-wrap: wrap;
            gap: 15px 0;
        }

        @media screen and (max-width: 768px) {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            height: 50px;
            overflow: hidden;
            background: var(--gray2);
            &.show {
                height: auto;
            }
        }

        li {
            list-style: none;
            position: relative;
            padding: 0 25px;

            @media screen and (max-width: 768px) {
                width: 100%;
                height: 50px;
                padding: 0;
            }

            a {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                width: 100%;
                height: 100%;
                font-size: 18px;
                color: var(--black2);

                @media screen and (max-width: 768px) {
                    font-size: 16px;
                }

                .dorp_arrow {
                    display: none;
                }
            }

            &.selected {
                a {
                    color: var(--orange);
                    text-decoration: underline;
                    text-underline-offset: 4px;
                }

                @media screen and (max-width: 768px) {
                    background-color: var(--orange);

                    a {
                        color: #fff;
                    }
                }
                // &::after {
                //   display: none;
                // }
            }

            &::after {
                content: '';
                width: 5px;
                height: 5px;
                border-radius: 10px;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                background: var(--gray1);

                @media screen and (max-width: 768px) {
                    width: 1px;
                    height: 20px;
                    background: var(--border-color3);
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                }
            }

            @media screen and (max-width: 768px) {
                &:nth-of-type(3n)::after {
                    display: none;
                }
            }

            &:last-child {
                &::after {
                    display: none;
                }
            }
        }
    }

    .hide_btn {
        display: none;
        width: 100%;
        height: 30px;
        align-items: center;
        justify-content: center;
        gap: 5px;
        margin-top: 30px;

        @media screen and (max-width: 768px) {
            display: flex;

            &.on {
                .drop_arrow {
                    transform: rotate(180deg);
                }
            }
        }

        .drop_arrow {
            display: flex;
            width: 12px;
            height: 8px;
        }
    }
}
</style>
